<template>
  <v-card>
    <v-card-title class="pb-0 pb-4">
      <v-icon class="mr-3" style="background:#e7e8e9; padding:10px; border-radius:50%;">mdi-file-plus</v-icon>
      <span>Nuevo Archivo</span>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-divider />

    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" md="6">
            <v-autocomplete
              :rules="[rules.required]"
              v-model="form.influencer_id"
              :items="influencerItems"
              :loading="isLoadingInfluencers"
              :search-input.sync="searchInfluencers"
              hide-no-data
              item-value="id"
              item-text="name"
              label="Influencer"
              placeholder="Escribe para buscar"
              clearable
            >
              <template v-slot:item="{ item, attrs, on }">
                <v-list-item v-on="on" v-bind="attrs">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                    <v-list-item-subtitle v-if="item.extra">{{ item.extra }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field :rules="[rules.required]" v-model="form.title" label="Título" />
          </v-col>

          

            <v-file-input
              :rules="[rules.fileRequired]"
              label="Archivo"
              accept="*/*"
              prepend-icon="mdi-paperclip"
              :loading="uploading"
              show-size
              counter
              @change="onFileSelected"
            />
            <div v-if="form.url" class="mt-1 grey--text text--darken-1" style="font-size:12px;">
              Archivo subido: <strong>{{ form.url }}</strong>
            </div>

            <v-col cols="12">
            <v-textarea v-model="form.description" label="Descripción" auto-grow />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text color="grey" @click="$emit('close')">Cancelar</v-btn>
      <v-btn color="primary" :disabled="!isValid" :loading="saving" @click="save">Guardar</v-btn>
    </v-card-actions>

    <v-snackbar :color="snackbar.color" v-model="snackbar.show">
      {{ snackbar.message }}
    </v-snackbar>
  </v-card>
</template>

<script>
import axios from 'axios'

export default {
  name: 'InfluencerFilesCreate',
  data: () => ({
    form: {
      title: '',
      description: '',
      url: '',               // <- aquí se guardará SOLO el nombre devuelto por el upload
      influencer_id: '',
      type: '',
      additional_data: null
    },
    additionalDataText: '',
    uploading: false,
    saving: false,
    snackbar: { show: false, message: null, color: null },

    searchInfluencers: '',
    isLoadingInfluencers: false,
    influencers: [],

    rules: {
      required: v => !!v || 'Campo requerido',
      fileRequired: v => !!v || 'Sube un archivo'
    },
  }),
  computed: {
    influencerItems () {
      const list = this.influencers || []
      return list.map(function (i) {
        return {
          id: i.id,
          name: (i.social_networks && i.social_networks.instagram) ? i.social_networks.instagram : (i.name || ('#' + i.id)),
          extra: i.name && i.last ? (i.name + ' ' + i.last) : (i.name || '')
        }
      })
    },
    isValid () {
      return !!this.form.influencer_id && !!this.form.title && !!this.form.url && !this.saving && !this.uploading
    }
  },
  watch: {
    searchInfluencers (val) {
      if (this.isLoadingInfluencers) return
      this.isLoadingInfluencers = true
      const base = process.env.VUE_APP_BACKEND_ROUTE + 'api/v1/influencer/search?'
      const url  = base + 'filter[social_networks]=' + encodeURIComponent(val || '')
      this.$nextTick(() => {
        axios.get(url)
          .then(res => {
            this.influencers = (res && res.data && res.data.data) ? res.data.data : []
          })
          .finally(() => { this.isLoadingInfluencers = false })
      })
    }
  },
  methods: {
    parseAdditionalData () {
      if (!this.additionalDataText) return null
      try { return JSON.parse(this.additionalDataText) }
      catch (e) {
        this.snackbar = { show: true, color: 'error', message: 'JSON inválido en Datos adicionales' }
        return '__INVALID__'
      }
    },
    async onFileSelected (fileOrArray) {
      const file = Array.isArray(fileOrArray) ? fileOrArray[0] : fileOrArray
      if (!file) return
      const formData = new FormData()
      formData.append('file', file)

      this.uploading = true
      try {
        // Usa el endpoint de tu ejemplo para subir y obtener el nombre
        const res = await axios({
          url: process.env.VUE_APP_BACKEND_ROUTE + 'api/v1/sale/file',
          method: 'POST',
          data: formData,
        })
        const name = (res && res.data && (res.data.file || res.data.filename || res.data.name)) ? (res.data.file || res.data.filename || res.data.name) : ''
        if (!name) throw new Error('Respuesta sin nombre de archivo')
        this.form.url = name  // << guardamos SÓLO el nombre
        this.snackbar = { show: true, color: 'success', message: 'Archivo subido' }
      } catch (err) {
        this.form.url = ''
        this.snackbar = { show: true, color: 'error', message: 'Error al subir archivo' }
      } finally {
        this.uploading = false
      }
    },
    async save () {
      const ad = this.parseAdditionalData()
      if (ad === '__INVALID__') return

      const payload = {
        title: this.form.title,
        description: this.form.description,
        url: this.form.url,                // el backend almacenará el nombre; para ver el archivo, armarás la URL pública
        influencer_id: this.form.influencer_id,
        type: this.form.type || '',
        additional_data: ad
      }

      this.saving = true
      try {
        await axios.post(process.env.VUE_APP_BACKEND_ROUTE + 'api/v1/influencer_files', payload)
        this.$emit('saved')
        this.snackbar = { show: true, color: 'success', message: 'Creado correctamente' }
      } catch (e) {
        this.snackbar = { show: true, color: 'error', message: 'No se pudo crear' }
      } finally {
        this.saving = false
      }
    },
  }
}
</script>
